
import NavigationBar from "../Components/LandingComponents/navbar";
import Hero from "../Components/LandingComponents/hero";
import Footer from "../Components/LandingComponents/footer";
import LoginModal from "../Components/LandingComponents/loginModal";

import React, { useState } from "react";


const LandingPage = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const openLogin = () => setShowLoginModal(true);
  const closeLogin = () => setShowLoginModal(false);

  return (
    <>
      <NavigationBar onLoginClick={openLogin} />
      <Hero onExploreNow={openLogin} />

      <LoginModal show={showLoginModal} handleClose={closeLogin} />

      <Footer />
    </>
  );
};

export default LandingPage;
